// Parse JSON -> FieldOverlay[] (spec §2 stop 2). Parse rects are 72-DPI points,
// top-left origin (document-parsing parse.schema.ts); FieldOverlay wants [0,1]
// fractions of the page, so divide by the page's own width/height.
import type { FieldOverlay } from '@/components/grounding/pdf-embed'

export interface ParseTextItem {
  text?: string
  x?: number
  y?: number
  width?: number
  height?: number
}
export interface ParsePage {
  pageNum?: number
  width?: number
  height?: number
  text?: string
  textItems?: ParseTextItem[]
  tables?: { bbox?: { x: number; y: number; width: number; height: number } }[]
}
export interface ParseJson {
  pages?: ParsePage[]
}

/** Stable id for a block: `p<page>:<index>` — the JSON tree uses the same key. */
export const blockId = (page: number, index: number) => `p${page}:${index}`

export function parseOverlays(json: ParseJson | undefined, activeId?: string): FieldOverlay[] {
  const out: FieldOverlay[] = []
  json?.pages?.forEach((page, pi) => {
    const w = page.width ?? 612
    const h = page.height ?? 792
    page.textItems?.forEach((item, i) => {
      if ([item.x, item.y, item.width, item.height].some((n) => typeof n !== 'number')) return
      const id = blockId(pi, i)
      out.push({
        id,
        page: pi,
        bbox: { x: item.x! / w, y: item.y! / h, width: item.width! / w, height: item.height! / h },
        active: id === activeId,
      })
    })
  })
  return out
}

/** Word count across pages — the "0 words -> N words" OCR comparison. */
export const wordCount = (json: ParseJson | undefined) =>
  (json?.pages ?? []).reduce(
    (n, p) => n + (p.text?.trim() ? p.text.trim().split(/\s+/).length : 0),
    0,
  )
